module.exports = __webpack_public_path__ + "static/media/RajeevAbeysekara.6d3f3aac.png";